export default __webpack_public_path__ + "82ba1be58810659c639683893c73c02b.png";